var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 3.28125C7.96985 3.28125 5.90625 5.34485 5.90625 7.875C5.90625 9.45667 6.71375 10.8615 7.93652 11.6895C5.59607 12.6943 3.9375 15.0168 3.9375 17.7188H5.25C5.25 14.8118 7.59302 12.4688 10.5 12.4688C13.407 12.4688 15.75 14.8118 15.75 17.7188H17.0625C17.0625 15.0168 15.4039 12.6943 13.0635 11.6895C14.2863 10.8615 15.0938 9.45667 15.0938 7.875C15.0938 5.34485 13.0302 3.28125 10.5 3.28125ZM10.5 4.59375C12.3201 4.59375 13.7812 6.05493 13.7812 7.875C13.7812 9.69507 12.3201 11.1562 10.5 11.1562C8.67993 11.1562 7.21875 9.69507 7.21875 7.875C7.21875 6.05493 8.67993 4.59375 10.5 4.59375Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.2e527b8b0b129f218e4e4151a2b6a726.svg";
export { ForwardRef as ReactComponent };